import React, { useEffect } from 'react';
import PriceTag from '@jbhi-fi/lanyard-ui/components/PriceTag';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';
import { OnlineProductPrice } from '@jbhi-fi/apis/src/shopify/types/OnlineProduct';
import { getProductPricing } from '@jbhi-fi/components/src/ProductCard/utils/getProductPricing';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { styles } from './Price.css';

export interface PriceProps {
  cartButton?: string;
  availability?: string;
  deliveryTag?: string;
  className?: string;
  buttonType?: string;
  variantAvailable?: boolean;
  isDigital?: boolean;
  fullWidth?: boolean;
  hideStrikeThrough?: boolean;
  isFloatingCta?: boolean;
  isPerksMember?: boolean;
  pricing: OnlineProductPrice;
  shouldShowWasPrice?: boolean;
  showPerksPrice?: boolean;
  isStickyDesktop?: boolean;
  toolTips?: Array<string>;
  bannerLabel?: string;
}

const Price = ({
  buttonType,
  className,
  deliveryTag,
  variantAvailable,
  isDigital,
  fullWidth,
  hideStrikeThrough,
  isFloatingCta,
  isPerksMember,
  pricing,
  shouldShowWasPrice,
  showPerksPrice,
  isStickyDesktop,
  toolTips,
  bannerLabel,
}: PriceProps): JSX.Element => {
  const idPrefix = useIdPrefix('price-cta');
  const shouldHidePerksExclusiveDealsFromNonMembers = window.Jbhifi.shouldHidePerksExclusiveDealsFromNonMembers;
  const regularPricing = {
    wasPrice: pricing.WasPrice,
    displayPriceAfterCashback: pricing.DisplayPriceAfterCashback,
    priceAfterCashback: pricing.PriceAfterCashback,
    displayPriceInc: pricing.DisplayPriceInc,
    displayWasPrice: pricing.DisplayWasPrice,
  };
  const perksPricing = {
    displayPriceAfterCashback: pricing?.PerksPricing?.DisplayPriceAfterCashback,
    displayPriceInc: pricing?.PerksPricing?.DisplayPriceInc,
    displayPriceTax: pricing?.PerksPricing?.DisplayPriceTax,
    displayWasPrice: pricing?.PerksPricing?.DisplayWasPrice,
    promoNamesApplied: pricing?.PerksPricing?.PromoNamesApplied || [],
    saveAmount: pricing?.PerksPricing?.SaveAmount,
    wasPrice: pricing?.PerksPricing?.WasPrice,
    wasPriceExpiryDate: pricing?.PerksPricing?.WasPriceExpiryDate,
  };
  const pricingValues = getProductPricing({
    pricing: regularPricing,
    shouldShowWasPrice,
    perksPricing,
    isPerksMember,
    showPerksPrice,
    shouldHidePerksExclusiveDealsFromNonMembers,
  });
  const buttonVariant =
    buttonType === 'DoNotDisplay' || !variantAvailable || isDigital || fullWidth ? 'default' : 'customButton';
  const hasMargin = !!fullWidth;

  return (
    <div
      className={classNames(styles.priceTagOverride({ buttonVariant, hasMargin, isStickyDesktop }))}
      id={useIdPrefix('price-tag-wrapper')}
    >
      <PriceTag
        id={idPrefix}
        actual={pricingValues?.actual ?? 0}
        ticket={hideStrikeThrough ? 0 : pricingValues?.ticket}
        cashback={pricingValues?.cashback}
        deliveryTag={deliveryTag}
        variant={isFloatingCta ? 'floatingCta' : isStickyDesktop ? 'small' : 'default'}
        perks={pricingValues?.perks}
        toolTips={toolTips}
        bannerLabel={bannerLabel}
        tooltipPosition={isFloatingCta ? 'top' : 'right-start'}
      />
    </div>
  );
};

export default Price;
